import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { PoetryWheel } from "./components";

function App() {
  return (
    <div className="App">
      <PoetryWheel />
    </div>
  );
}

export default App;
